module.exports = __webpack_public_path__ + "img/code-security-icon.dccf005a.svg";